export default "/images/StorySoft.png?96000a19061fb992c7cdf0d92218b977";